import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBreakthroughFuelHold extends Layout {
    buttonDownload: Button;
    buttonRemoveHold: Button;
    sourceBreakthroughTransaction: DataSource;
    tableBreakthrough: Table;
}
